import { trigger, state, style, transition, animate } from "@angular/animations";
import { ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Animations, HelperMethods } from "src/app/shared";
import { AssistantData } from "../../../models/assistant-data";
import { AssistantUiComponent } from "../../../models/assistant-ui-component";
import { AssistantService } from "../../../services/assistant.service";

@Component({
    selector: "app-assistant-banner",
    templateUrl: "./assistant-banner.component.html",
    styleUrls: ["./assistant-banner.component.scss"],
    animations: [
        trigger("slideContent", [
            state("void", style({ transform: "translateY(80%) translateX(80%) scale(0)", opacity: 0 })),
            state("enter", style({ transform: "none", opacity: 1 })),
            transition("void => enter", animate("300ms ease-in")),
            transition("enter => void", animate("225ms ease-out")),
        ]),
        Animations.buildCustomTimedFadeInAnimation("325ms 455ms ease-in"),
    ],
    standalone: false
})
export class AssistantBannerComponent implements OnInit, OnDestroy, AssistantUiComponent {
  private _destroyed$: Subject<void> = new Subject<void>();

  @HostBinding("@slideContent") slideContent = "enter";

  showContent: boolean = false;
  data: AssistantData;

  constructor(private assistantService: AssistantService, private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    //TODO delay run required for fade anim, why?
    HelperMethods.delayRun(1, () => {
      this.showContent = true;
    });

    this.assistantService.data$.pipe(takeUntil(this._destroyed$)).subscribe({
      next: data => {
        this.data = data;
        this.cdRef.detectChanges();
      },
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  onMinimize(): void {
    this.assistantService.close(true);
  }
}
